const version2 = [
    //借款申请第二版

    {
      path: '/version2/base-info',
      component: () => import('@/pages/version2/credit/base-info.vue'),
      meta: {
        title: '基本信息',
        keepAlive: false
      }
    },
    {
      path: '/version2/person-contact',
      component: () => import('@/pages/version2/credit/person-contact.vue'),
      meta: {
        title: '联系人信息',
        keepAlive: false
      }
    },
    //撞库申请免费用户
    {
      path: '/version2/match-loading-f',
      component: () => import('@/pages/version2/credit/match-loading-f.vue'),
      meta: {
        title: '申请中',
        keepAlive: false
      }
    },
    //撞库申请付费用户
    {
      path: '/version2/match-loading-v',
      component: () => import('@/pages/version2/credit/match-loading-v.vue'),
      meta: {
        title: '申请中',
        keepAlive: false
      }
    },



    //申请成功结果
    {
      path: '/version2/result-page-success',
      component: () => import('@/pages/version2/credit/result-page-success.vue'),
      meta: {
        title: '额度评估中',
        keepAlive: false
      }
    },
    //申请失败结果
    {
      path: '/version2/result-page-fail',
      component: () => import('@/pages/version2/credit/result-page-fail.vue'),
      meta: {
        title: '申请失败',
        keepAlive: false
      }
    },
    //p0协议页面
    {
      path: '/version2/agreement',
      component: () => import('@/pages/version2/credit/agreement.vue'),
      meta: {
        title: '协议',
        keepAlive: false
      }
    },


    //智能借款方案
    {
      path: '/version2/right-introduce',
      component: () => import('@/pages/version2/vip/right-introduce.vue'),
      meta: {
        title: '智能借款方案',
        keepAlive: false
      }
    },
    //智能借款方案
    {
      path: '/version2/vipright',
      component: () => import('@/pages/version2/vip/vipright.vue'),
      meta: {
        title: '智能借款方案',
        keepAlive: false
      }
    },



  ]
export default version2



// WEBPACK FOOTER //
// ./src/router/modules/version2.js